var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { Relationship, RelationshipMapConverter } from './Schema';
import { Any, JsonConvert, JsonConverter, JsonObject, JsonProperty } from 'json2typescript';
var jsonConvert = new JsonConvert();
export var MongoDBRuleRelationship = Relationship;
var MongoDBRulePermissions = (function () {
    function MongoDBRulePermissions(partial) {
        this.write = undefined;
        this.read = undefined;
        Object.assign(this, partial);
    }
    __decorate([
        JsonProperty('write', Any, true),
        __metadata("design:type", Object)
    ], MongoDBRulePermissions.prototype, "write", void 0);
    __decorate([
        JsonProperty('read', Any, true),
        __metadata("design:type", Object)
    ], MongoDBRulePermissions.prototype, "read", void 0);
    MongoDBRulePermissions = __decorate([
        JsonObject('MongoDBRulePermissions'),
        __metadata("design:paramtypes", [Object])
    ], MongoDBRulePermissions);
    return MongoDBRulePermissions;
}());
export { MongoDBRulePermissions };
var MongoDBRuleField = (function () {
    function MongoDBRuleField(partial) {
        this.fields = undefined;
        this.read = undefined;
        this.write = undefined;
        this.additionalFields = undefined;
        Object.assign(this, partial);
    }
    __decorate([
        JsonProperty('fields', Any, true),
        __metadata("design:type", Object)
    ], MongoDBRuleField.prototype, "fields", void 0);
    __decorate([
        JsonProperty('read', Any, true),
        __metadata("design:type", Object)
    ], MongoDBRuleField.prototype, "read", void 0);
    __decorate([
        JsonProperty('write', Any, true),
        __metadata("design:type", Object)
    ], MongoDBRuleField.prototype, "write", void 0);
    __decorate([
        JsonProperty('additional_fields', MongoDBRulePermissions, true),
        __metadata("design:type", MongoDBRulePermissions)
    ], MongoDBRuleField.prototype, "additionalFields", void 0);
    MongoDBRuleField = __decorate([
        JsonObject('MongoDBRuleField'),
        __metadata("design:paramtypes", [Object])
    ], MongoDBRuleField);
    return MongoDBRuleField;
}());
export { MongoDBRuleField };
var serializeMongoDBRuleField = function (ruleField) {
    var ruleFieldData = jsonConvert.serializeObject(ruleField, MongoDBRuleField);
    if (ruleField.fields) {
        var fields = Object.entries(ruleField.fields).reduce(function (fieldMap, _a) {
            var _b;
            var _c = __read(_a, 2), key = _c[0], fieldData = _c[1];
            return (__assign(__assign({}, fieldMap), (_b = {}, _b[key] = serializeMongoDBRuleField(fieldData), _b)));
        }, {});
        ruleFieldData = __assign(__assign({}, ruleFieldData), { fields: fields });
    }
    return ruleFieldData;
};
var deserializeMongoDBRuleField = function (data) {
    var ruleField = jsonConvert.deserializeObject(data, MongoDBRuleField);
    if ('fields' in data) {
        var fields = Object.entries(data.fields).reduce(function (fieldMap, _a) {
            var _b;
            var _c = __read(_a, 2), key = _c[0], fieldData = _c[1];
            return (__assign(__assign({}, fieldMap), (_b = {}, _b[key] = deserializeMongoDBRuleField(fieldData), _b)));
        }, {});
        ruleField = new MongoDBRuleField(__assign(__assign({}, ruleField), { fields: fields }));
    }
    return ruleField;
};
var MongoDBRuleFieldMapConverter = (function () {
    function MongoDBRuleFieldMapConverter() {
    }
    MongoDBRuleFieldMapConverter.prototype.serialize = function (fieldMap) {
        return Object.entries(fieldMap).reduce(function (dataMap, _a) {
            var _b;
            var _c = __read(_a, 2), key = _c[0], fieldRule = _c[1];
            return (__assign(__assign({}, dataMap), (_b = {}, _b[key] = serializeMongoDBRuleField(fieldRule), _b)));
        }, {});
    };
    MongoDBRuleFieldMapConverter.prototype.deserialize = function (data) {
        return Object.entries(data).reduce(function (fieldMap, _a) {
            var _b;
            var _c = __read(_a, 2), key = _c[0], fieldData = _c[1];
            return (__assign(__assign({}, fieldMap), (_b = {}, _b[key] = deserializeMongoDBRuleField(fieldData), _b)));
        }, {});
    };
    MongoDBRuleFieldMapConverter = __decorate([
        JsonConverter
    ], MongoDBRuleFieldMapConverter);
    return MongoDBRuleFieldMapConverter;
}());
var MongoDBRuleRole = (function () {
    function MongoDBRuleRole(partial) {
        this.name = '';
        this.applyWhen = {};
        this.fields = undefined;
        this.read = undefined;
        this.write = undefined;
        this.insert = undefined;
        this.delete = undefined;
        this.additionalFields = undefined;
        Object.assign(this, partial);
    }
    __decorate([
        JsonProperty('name'),
        __metadata("design:type", Object)
    ], MongoDBRuleRole.prototype, "name", void 0);
    __decorate([
        JsonProperty('apply_when'),
        __metadata("design:type", Object)
    ], MongoDBRuleRole.prototype, "applyWhen", void 0);
    __decorate([
        JsonProperty('fields', MongoDBRuleFieldMapConverter, true),
        __metadata("design:type", Object)
    ], MongoDBRuleRole.prototype, "fields", void 0);
    __decorate([
        JsonProperty('read', Any, true),
        __metadata("design:type", Object)
    ], MongoDBRuleRole.prototype, "read", void 0);
    __decorate([
        JsonProperty('write', Any, true),
        __metadata("design:type", Object)
    ], MongoDBRuleRole.prototype, "write", void 0);
    __decorate([
        JsonProperty('insert', Any, true),
        __metadata("design:type", Object)
    ], MongoDBRuleRole.prototype, "insert", void 0);
    __decorate([
        JsonProperty('delete', Any, true),
        __metadata("design:type", Object)
    ], MongoDBRuleRole.prototype, "delete", void 0);
    __decorate([
        JsonProperty('additional_fields', MongoDBRulePermissions, true),
        __metadata("design:type", MongoDBRulePermissions)
    ], MongoDBRuleRole.prototype, "additionalFields", void 0);
    MongoDBRuleRole = __decorate([
        JsonObject('MongoDBRuleRole'),
        __metadata("design:paramtypes", [Object])
    ], MongoDBRuleRole);
    return MongoDBRuleRole;
}());
export { MongoDBRuleRole };
var MongoDBRuleFilter = (function () {
    function MongoDBRuleFilter(partial) {
        this.name = '';
        this.query = {};
        this.projection = undefined;
        this.applyWhen = {};
        Object.assign(this, partial);
    }
    __decorate([
        JsonProperty('name'),
        __metadata("design:type", Object)
    ], MongoDBRuleFilter.prototype, "name", void 0);
    __decorate([
        JsonProperty('query'),
        __metadata("design:type", Object)
    ], MongoDBRuleFilter.prototype, "query", void 0);
    __decorate([
        JsonProperty('projection', Any, true),
        __metadata("design:type", Object)
    ], MongoDBRuleFilter.prototype, "projection", void 0);
    __decorate([
        JsonProperty('apply_when'),
        __metadata("design:type", Object)
    ], MongoDBRuleFilter.prototype, "applyWhen", void 0);
    MongoDBRuleFilter = __decorate([
        JsonObject('MongoDBRuleFilter'),
        __metadata("design:paramtypes", [Object])
    ], MongoDBRuleFilter);
    return MongoDBRuleFilter;
}());
export { MongoDBRuleFilter };
var MongoDBRule = (function () {
    function MongoDBRule(partial) {
        this.id = undefined;
        this.database = '';
        this.collection = '';
        this.filter = undefined;
        this.roles = undefined;
        this.schema = undefined;
        this.relationships = undefined;
        Object.assign(this, partial);
    }
    __decorate([
        JsonProperty('_id', String, true),
        __metadata("design:type", String)
    ], MongoDBRule.prototype, "id", void 0);
    __decorate([
        JsonProperty('database'),
        __metadata("design:type", Object)
    ], MongoDBRule.prototype, "database", void 0);
    __decorate([
        JsonProperty('collection'),
        __metadata("design:type", Object)
    ], MongoDBRule.prototype, "collection", void 0);
    __decorate([
        JsonProperty('filter', MongoDBRuleFilter, true),
        __metadata("design:type", MongoDBRuleFilter)
    ], MongoDBRule.prototype, "filter", void 0);
    __decorate([
        JsonProperty('roles', [MongoDBRuleRole], true),
        __metadata("design:type", Array)
    ], MongoDBRule.prototype, "roles", void 0);
    __decorate([
        JsonProperty('schema', Any, true),
        __metadata("design:type", Object)
    ], MongoDBRule.prototype, "schema", void 0);
    __decorate([
        JsonProperty('relationships', RelationshipMapConverter, true),
        __metadata("design:type", Object)
    ], MongoDBRule.prototype, "relationships", void 0);
    MongoDBRule = __decorate([
        JsonObject('MongoDBRule'),
        __metadata("design:paramtypes", [Object])
    ], MongoDBRule);
    return MongoDBRule;
}());
export { MongoDBRule };
var PartialMongoDBRule = (function () {
    function PartialMongoDBRule(partial) {
        this.id = '';
        this.database = '';
        this.collection = '';
        Object.assign(this, partial);
    }
    __decorate([
        JsonProperty('_id'),
        __metadata("design:type", Object)
    ], PartialMongoDBRule.prototype, "id", void 0);
    __decorate([
        JsonProperty('database'),
        __metadata("design:type", Object)
    ], PartialMongoDBRule.prototype, "database", void 0);
    __decorate([
        JsonProperty('collection'),
        __metadata("design:type", Object)
    ], PartialMongoDBRule.prototype, "collection", void 0);
    PartialMongoDBRule = __decorate([
        JsonObject('PartialMongoDBRule'),
        __metadata("design:paramtypes", [Object])
    ], PartialMongoDBRule);
    return PartialMongoDBRule;
}());
export { PartialMongoDBRule };
var BuiltinRule = (function () {
    function BuiltinRule(partial) {
        this.id = undefined;
        this.name = '';
        this.actions = [];
        this.when = undefined;
        Object.assign(this, partial);
    }
    __decorate([
        JsonProperty('_id', String, true),
        __metadata("design:type", String)
    ], BuiltinRule.prototype, "id", void 0);
    __decorate([
        JsonProperty('name'),
        __metadata("design:type", Object)
    ], BuiltinRule.prototype, "name", void 0);
    __decorate([
        JsonProperty('actions', [String]),
        __metadata("design:type", Array)
    ], BuiltinRule.prototype, "actions", void 0);
    __decorate([
        JsonProperty('when', Any, true),
        __metadata("design:type", Object)
    ], BuiltinRule.prototype, "when", void 0);
    BuiltinRule = __decorate([
        JsonObject('BuiltinRule'),
        __metadata("design:paramtypes", [Object])
    ], BuiltinRule);
    return BuiltinRule;
}());
export { BuiltinRule };
var PartialBuiltinRule = (function () {
    function PartialBuiltinRule(partial) {
        this.id = '';
        this.name = '';
        Object.assign(this, partial);
    }
    __decorate([
        JsonProperty('_id'),
        __metadata("design:type", Object)
    ], PartialBuiltinRule.prototype, "id", void 0);
    __decorate([
        JsonProperty('name'),
        __metadata("design:type", Object)
    ], PartialBuiltinRule.prototype, "name", void 0);
    PartialBuiltinRule = __decorate([
        JsonObject('PartialBuiltinRule'),
        __metadata("design:paramtypes", [Object])
    ], PartialBuiltinRule);
    return PartialBuiltinRule;
}());
export { PartialBuiltinRule };
export var deserializeRule = function (data) {
    if ('database' in data) {
        return jsonConvert.deserializeObject(data, MongoDBRule);
    }
    return jsonConvert.deserializeObject(data, BuiltinRule);
};
export var deserializePartialRule = function (data) {
    if ('database' in data) {
        return jsonConvert.deserializeObject(data, PartialMongoDBRule);
    }
    return jsonConvert.deserializeObject(data, PartialBuiltinRule);
};
var RulesConverter = (function () {
    function RulesConverter() {
    }
    RulesConverter.prototype.serialize = function (rules) {
        return jsonConvert.serializeArray(rules);
    };
    RulesConverter.prototype.deserialize = function (rulesData) {
        if (!(rulesData instanceof Array)) {
            throw new Error('expected rules to be an array');
        }
        return Object.values(rulesData).map(deserializeRule);
    };
    RulesConverter = __decorate([
        JsonConverter
    ], RulesConverter);
    return RulesConverter;
}());
export { RulesConverter };
//# sourceMappingURL=Rule.js.map